// Handler slot calculation utilities for race dashboard
// Reusable functions for approved/pending birds and available slots

export const getApprovedBirdsForHandler = (handlerRequests, handlerId) => {
  return handlerRequests
    .filter(r => r.handlerId === handlerId && r.status === 'approved')
    .reduce((total, r) => total + r.numberOfBirds, 0);
};

export const getApprovedAndPendingBirdsForHandler = (handlerRequests, handlerId, breederId) => {
  return handlerRequests
    .filter(r => r.handlerId === handlerId && r.breederId === breederId && (r.status === 'approved' || r.status === 'pending'))
    .reduce((total, r) => total + r.numberOfBirds, 0);
};

export const getRemainingBirdSlotsForHandler = (handlerRequests, handlerId, breederId, maxSlots = 5) => {
  return maxSlots - getApprovedAndPendingBirdsForHandler(handlerRequests, handlerId, breederId);
};
